import React, { useEffect, useState } from 'react'
import { useParams } from "react-router";
import localStorageService from '../services/localStorageService';
import portalService from '../services/portalService';
import { Link, NavLink } from 'react-router-dom';

const BoxPrices = () => {
    let { id, boxId } = useParams();
    const [box, setBox] = useState({});
    const [price, setPrice] = useState(0);
    const [selectedSchedules, setSelectedSchedules] = useState(0);

    useEffect(() => {
        const items = localStorageService.items.get();
        const item = items[boxId];
        console.log("Found item", item);
        console.log(item.schedules);
        const valid = getValidSchedules(item);
        if (valid.length > 0) {
            setSelectedSchedules(valid[0].id);
        }
        setBox(item);
    }, [id, boxId]);

    const clearFields = (item) => {
        setPrice(0);
        const valid = getValidSchedules(item) || [];
        if (valid.length > 0) {
            console.log("clearing fields. Setting schedule", valid[0].id);
            setSelectedSchedules(valid[0].id);
        }
    }

    const modalClosed = (e) => {
        clearFields(box);
    }

    const addNew = (e) => {
        console.log("selected", price, selectedSchedules);
        portalService.addPrice({
            boxId,
            scheduleId: selectedSchedules,
            price
        }).then(r => {
            const newItem = r.data;
            const existingLocations = localStorageService.locations.get();
            const existingLocation = existingLocations[id];
            const existingItems = [...existingLocation.storageItems];
            const updatedItems = existingItems.map(i => i.id == newItem.id ? newItem: i);
            existingLocation.storageItems = updatedItems;
            existingLocations[id] = existingLocation;
            localStorageService.locations.set(existingLocations);

            const items = localStorageService.items.get();
            items[boxId] = newItem;
            localStorageService.items.set(items);
            setBox(newItem);
            clearFields(newItem);
        }).catch(e => {
            console.log(e);
        }).finally(() => {
            
        })
    }

    const getValidSchedules = (currentItem) => {
        const existingSchedules = (currentItem.schedules || []).map(s => s.scheduleId) || [];
        console.log("existingSchedules", existingSchedules);
        const validSchedules = localStorageService.schedules.get().filter(s => !existingSchedules.includes(s.id));
        console.log("validSchedules", validSchedules)
        return validSchedules;
    }

    const modal = () => {
        return (
            <div className="modal fade" id="new-box-price" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 v="modal-title fs-5" id="staticBackdropLabel">Добавить цену</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form className="form-floating">
                                <div className="mb-3">
                                    <label htmlFor="new-box-schedules">Период</label>
                                    <select className="form-select" id="new-box-schedules" aria-label="Default select example"
                                        value={selectedSchedules}
                                        onChange={e => {
                                            setSelectedSchedules(e.target.value);
                                        }}>
                                            {getValidSchedules(box).map(c => (
                                                <option key={`box-schedules-${c.id}`} value={c.id}>{c.displayName}</option>
                                            ))}
                                    </select>
                                    
                                </div>
                                <div className="form-floating mb-3">
                                    <input type="number" className="form-control" id="new-box-price" required placeholder="" value={price} onChange={(e) => setPrice(e.target.value)}/>
                                    <label htmlFor="new-box-price">Цена</label>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={modalClosed}>Закрыть</button>
                                    <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={addNew}>Сохранить</button>
                                </div>
                            </form>
                        </div>       
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="">
            <Link className="btn btn-outline-primary btn-sm mb-5" to={`/locations/${id}`}>&lt;Назад</Link>
            <h2>Цены для ячейки {box.boxCode}{box.boxNum}</h2>
            <hr/>
            <div>
                <table className="table table-striped table-hover">
                    <thead className="table">
                        <tr>
                            <th scope="col">Период</th>
                            <th scope="col">Цена тг/м</th>
                        </tr>
                    </thead>
                    <tbody>
                        {box && box.schedules && box.schedules.map((row) => (
                            <tr key={row.id}>
                                <td>{row.schedule.displayName}</td>
                                <td>{row.price}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div>
                    <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#new-box-price">Добавить+</button>
                </div>
                {modal()}
            </div>
        </div>
    )
}

export default BoxPrices;